// =============================================================================
//  Copyright : 2020 semantics GmbH
//  Date      : $Date: 2021-09-01 00:07:37 +0200 (Wed, 01 Sep 2021) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 121189 $
//  Purpose   : qa specific wiki elements
// =============================================================================
// ---Third-party imports
import React from 'react'
import {JSONTree} from 'uix/chunks'

// ---Framework imports
import {mapItems, strip, isString} from 'ldash'
import log from 'uix/logging'
import {Actions, Sel} from 'uix/registries'
import {decodeAttribH5, hashObj} from 'uix/utils'
import {TagMatcher} from 'uix/wiki/utils'
import {TreeTable} from 'uix/db/table'
import {useTreeList} from 'uix/db/hooks'
import {HeaderSegment, XMenu} from 'uix/components'
import {useState} from 'uix/hooks'

// ---Exports

export const MetadataTableMatcher = TagMatcher(
  'MetadataTable',
  ({states, numrows, groupby, header = 'List', columns = 'tcaption,domain', link}) => {
    let params = {typeName: 'metadata', subdomains: true}
    let [selectable, setSelectable] = useState(false)

    if (states) {
      params.stateNames = states
    }

    let options = {selectable, filterable: true, groupable: true}
    if (groupby) {
      options.groupBy = groupby
    }
    numrows = parseInt(numrows) || 10

    columns = columns
      ? columns
          .split(',')
          .map(e => strip(e))
          .filter(e => e)
      : columns

    let buildLink = undefined
    if (isString(link)) {
      let target = {classname: 'tree', tabname: 'id'}
      if (link.includes('/')) {
        let [s1, s2] = link.split('/')
        target.classname = s1
        target.tabname = s2
      } else {
        target.tabname = link
      }
      buildLink = () => target
    }
    let menu = (
      <XMenu>
        <XMenu.Toggle
          set={setSelectable}
          value={selectable}
          icon="check"
          title="Select/Copy VLIDs"
        />
      </XMenu>
    )
    let {treeList, loading} = useTreeList(`mdtable_${hashObj(params)}`, params)
    return (
      <HeaderSegment header={header} loading={loading} icon="list" menu={menu}>
        <TreeTable
          options={options}
          defaultPageSize={numrows}
          data={treeList}
          defaultColumns={columns}
          buildLink={buildLink}
        />
      </HeaderSegment>
    )
  },
  {
    states: ['qs:'],
    groupby: ['release.value'],
    numrows: ['8'],
    columns: ['tcaption,domain'],
    header: ['Liste'],
    link: ['tree/id', 'tree/states'],
  }
)
